import { Skill } from "@/models/skill";
import { Pagination } from "@/models/pagination";
import { ISkill, SkillState } from "@/types/skill";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<SkillState, ISkill> = {
  single: (state, single) => {
    state.single = new Skill(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Skill(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Skill();
    state.pagination = new Pagination();
  },
};

export default mutations;
